<script lang="ts">
  export let height: number;
  export let userScore: number;
  export let userHighScore: number;
</script>

<!-- SCORE DIV -->
<div class="scores" style="font-size: {0.04 * height}px; top: {0.06 * height}px;">
  <div style="float: left">Score: {userScore}</div>
  <div style="float: right">High Score: {userHighScore}</div>
</div>

<style lang="postcss">
  .scores {
    position: absolute;
    left: 10%;
    width: 80%;
    color: white;
    z-index: 100;
  }
</style>
